const { debounce } = window.BAO.Utils
class StickyHeader extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        position: sticky;
        top: 0;
        z-index: 10;
        display: block;
        background-color: #fff;
      }
    `
  }

  constructor () {
    super()

    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.updateEl.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', debounce(this.onResize, 250))
  }

  onScroll () {
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false
    const stuckHeight = this.offsetHeight

    document.documentElement.style.setProperty(
      '--Search_Start',
      `${this.getBoundingClientRect().bottom}px`,
    )

    if (this.lastKnownY > stuckHeight) {
      this.setAttribute('stuck', '')
      document.body.setAttribute('stuck', '')
    } else {
      this.removeAttribute('stuck')
      document.body.removeAttribute('stuck')
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
